<template>
<div>
	<button v-if="!isFinalized" class="btn btn-primary mt-2 float-right" v-on:click="addAdditionalFactor">
		<i class="fa fa-plus"></i>
		Add
	</button>

	<table-list
		record-name="Additional Factor"
		:fields="additionalFactorFields"
		:hide-record-count="true"
		:records="mutatedAdditionalFactors"
		:simple-delete="true"
		:has-delete="!isFinalized"
		:has-edit="!isFinalized"
		:sortable="true"
		v-on:edit="editAdditionalFactor"
		v-on:delete="removeAdditionalFactor">
	</table-list>

	<info-box class="float-right mb-2"
		label="Total" 
		:value="mutatedAdditionalFactors.reduce((acc,factor) => acc + factor.totalRaw,0).toCurrency()">
	</info-box>
	<div style="clear: both;"></div>

	<modal-dialog :modal-visible="additionalFactorsModal.visible"
		:title="additionalFactorsModal.title"
		confirm-button-text="Save"
		modal-size="modal-lg"
		v-on:confirm="confirmAddAdditionalFactor"
		v-on:closeModal="additionalFactorsModal.visible = false">

		<field label="Description"
			col-class="col-md-4"
			:params="{type:'text'}"
			v-model="additionalFactorsModal.payload.description">
		</field>

		<form-group label="Variable & Scope"
					col-class="col-md-4">

			<div class="d-flex justify-content-between align-items-center">
				<div class="d-flex justify-content-between align-items-center">
					<field
						:params="{
							type:'select',
							options: variableOptions
						}"
						v-model="additionalFactorsModal.payload.variable"
						v-on:change="variableChange">
					</field>

					<field v-if="additionalFactorsModal.payload.variable != 'flat-rate'"
						:params="{
							type:'select',
							options: additionalFactorVariableScopeOptions
						}"
						v-model="additionalFactorsModal.payload.variableScope"
						v-on:change="variableChange">
					</field>
				</div>

				<field v-if="additionalFactorsModal.payload.variable != 'flat-rate'"
					:value="getAdditionalFactorVariableValue(additionalFactorsModal.payload.variable,additionalFactorsModal.payload.variableScope,$store.projectBidObjects,component.id).toFixed(2)"
					:params="{
						type: 'static',
						align: 'right'
					}">		
				</field>
			</div>
		</form-group>

		<div v-if="additionalFactorsModal.payload.variable != 'flat-rate'">
				<form-group v-for="(operand,index) in additionalFactorsModal.operands"
				:label="'Operand ' + (index+1)"
				col-class="col-md-4">

				<div class="d-flex align">

					<field
						:params="{
							type:'select',
							options: [
								{text: 'Multiply by',value:'multiply'},
								{text: 'Divide by',value:'divide'}
							]
						}"
						v-model="operand.operator"
						v-on:change="recalculateFactor">
					</field>

					<field
						:params="{
							type:'number',
							placeholder: 'Value',
							step: 0.0001
						}"
						v-model="operand.value"
						v-on:change="recalculateFactor">
					</field>

					<field
						:params="{
							type:'text',
							placeholder: 'Label'
						}"
						v-model="operand.label">
					</field>
					<div style="margin: 8px;">
						<i v-if="additionalFactorsModal.operands.length > 1" class="fa fa-trash icon-button" v-on:click="removeOperand(index)"></i>
					</div>

					<field
						:params="{
							type:'static',
							placeholder: 'Product',
							align: 'right'
						}"
						:readonly="true"
						:value="operand.product ? operand.product.toCurrency() : '0.00'">
					</field>

				</div>

			</form-group>

			<button class="btn btn-primary float-right mb-2" type="button" v-on:click="addAdditionalFactorOperand">
				<i class="fa fa-plus"></i>
				Add Operand
			</button>

		</div>
		<div v-else>
			<field label="Value"
				col-class="col-md-4"
				v-model="additionalFactorsModal.finalValue"
				:params="{
					type: 'number',
					step: 0.01
				}">
			</field>
		</div>

		<div style="clear: both;"></div>

		<info-box class="float-right"
			:stacked="true"
			label="Total Value" 
			:value="additionalFactorsModal.finalValue ? additionalFactorsModal.finalValue.toCurrency() : '0.00'">
		</info-box>

	</modal-dialog>
</div>
</template>
<script type="text/javascript">
import TableList from "@/components/TableList"
import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"
import FormGroup from "@/components/FormGroup"
import InfoBox from "@/components/InfoBox"

import ProjectBidMixins from "@/mixins/ProjectBidMixins.js"

export default {
	name: "AdditionalFactorsSection",
	components: {
		TableList,
		ModalDialog,
		Field,
		FormGroup,
		InfoBox
	},
	mixins: [ProjectBidMixins],
	props: ["additionalFactors","component","isFinalized"],
	data() {
		return {
			additionalFactorsLocal: [],
			additionalFactorsVariablesInUse: {}, //a place to store the live-calculated additional factor variables that are currently being used in the additional factors section
			additionalFactorsModal: {
				visible: false,
				title: "",
				objectRecordId: null,
				payload: {},
				operands: [],
				finalValue: null,
				objectRecordId: null
			}
		}
	},
	watch: {
		additionalFactors() {
			this.additionalFactorsLocal = this.additionalFactors
		},
		component() {
			this.fetchComponentDescendantIds(this.component.id)
		}
	},
	computed: {
		variableValueAndScope() {
			return this.additionalFactorsModal.payload.variable + "-" + this.additionalFactorsModal.payload.variableScope
		},
		mutatedAdditionalFactors() {
			let vm = this

			/*
			key:'description'},
				{label: 'Variable',key:'variableFormatted'},
				{label: 'Factors',key:'operandsAppended'},
				{label: 'Total',key:'totalFormatted',align: "right"},
			*/

			return this.additionalFactorsLocal.map(factor => this.mutateAdditionalFactor(factor,this.component.id))
		}
	},
	methods: {
		variableChange() {

		},
		addAdditionalFactor() {
			this.additionalFactorsModal.visible = true
			this.additionalFactorsModal.title = "Add Factor"
			this.additionalFactorsModal.payload = {}
			this.additionalFactorsModal.operands = []
			this.additionalFactorsModal.finalValue = 0

			this.fetchBidObjects(this.component.bid_id)

			this.addAdditionalFactorOperand()
		},
		editAdditionalFactor(factor) {
			this.additionalFactorsModal.visible = true
			this.additionalFactorsModal.title = "Edit Factor"
			this.additionalFactorsModal.payload = {
				description: factor.description,
				variable: factor.variable,
				variableScope: factor.variableScope
			}
			this.additionalFactorsModal.objectRecordId = factor.objectRecordId

			this.additionalFactorsModal.operands = factor.operands
			this.recalculateFactor()
		},
		removeAdditionalFactor(factor) {
			let vm = this

			this.postData("JobBidComponentObject/delete",{id: factor.objectRecordId},true).then(response => {
				if (response.success)
					vm.$emit("modelChanged")
			})
		},
		addAdditionalFactorOperand() {
			this.additionalFactorsModal.operands.push({
				label: "",
				operator: null,
				value: null,
				product: null
			})
		},
		removeOperand(index) {
			this.additionalFactorsModal.operands.splice(index,1)
			this.recalculateFactor()
		},
		confirmAddAdditionalFactor() {
			let vm = this

			let fieldValues = {
				description: this.additionalFactorsModal.payload.description,
				variable: this.additionalFactorsModal.payload.variable
			}

			if (fieldValues.variable != 'flat-rate') {
				fieldValues.variableScope = this.additionalFactorsModal.payload.variableScope
				fieldValues.operands = this.additionalFactorsModal.operands
			}
			else 
				fieldValues.value = this.additionalFactorsModal.finalValue

			let payload = {
				bid_component_id: this.component.id,
				type: "AdditionalFactor",
				field_values_json: JSON.stringify(fieldValues)
			}

			if ("objectRecordId" in this.additionalFactorsModal && this.additionalFactorsModal.objectRecordId > 0)
				payload.id = this.additionalFactorsModal.objectRecordId

			this.postData("JobBidComponentObject/save",payload,true).then(response => {
				if (response.success) {
					vm.$emit("modelChanged")
					vm.additionalFactorsModal.visible = false
				}
			})
		},
		recalculateFactor() {
			let vm = this

			this.$nextTick(() => {

				let runningProduct = vm.getAdditionalFactorVariableValue(vm.additionalFactorsModal.payload.variable,vm.additionalFactorsModal.payload.variableScope,vm.$store.projectBidObjects,vm.component.id)

				vm.additionalFactorsModal.operands.forEach(op => {
					if (op.operator == 'multiply') 
						runningProduct *= op.value
					else if (op.operator == 'divide') 
						runningProduct /= op.value

					op.product = runningProduct
				})

				vm.additionalFactorsModal.finalValue = runningProduct
			})
		},
	},
	created() {
		if (this.component)
			this.fetchComponentDescendantIds(this.component.id)

		this.additionalFactorsLocal = this.additionalFactors
	}

}
</script>